const fanBackendUrl = process.env.REACT_APP_FAN_BACKEND_BASE_URL
  ? process.env.REACT_APP_FAN_BACKEND_BASE_URL
  : 'http://localhost:8080/v1';

const config = {
  FAN_BACKEND_BASE_URL: fanBackendUrl,
};

export default config;
